import { Button } from "@ui/Button"
import { Dialog } from "@ui/Dialog"

export default function ConfirmModal({ isOpen, onClose, onConfirm, title, message, confirmLabel = "Confirm", destructive = false }) {
  return (
    <Dialog.Root open={isOpen} onOpenChange={(o) => { if (!o) onClose() }}>
      <Dialog.Content size="sm">
        <Dialog.Header>
          <Dialog.Title>{title}</Dialog.Title>
        </Dialog.Header>
        <Dialog.Body>
          <p className="text-sm text-webex-gray-700 dark:text-webex-gray-300 text-center">{message}</p>
        </Dialog.Body>
        <Dialog.Footer>
          <Button variant="secondary" onClick={onClose}>Cancel</Button>
          <Button variant={destructive ? "cancel" : "primary"} onClick={onConfirm}>
            {confirmLabel}
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Root>
  )
}
